import { useSettings } from '@/modules/settings-api'

export const CART_STORAGE_KEY = 'xedien.cart.v1'
export const FREE_SHIPPING_THRESHOLD = 5_000_000
export const DEFAULT_SHIPPING_FEE = 50_000

export function useShippingConfig() {
  const { data: s } = useSettings()
  return {
    freeShippingThreshold: s.freeShippingThreshold,
    defaultShippingFee: s.defaultShippingFee,
  }
}
